import { useState } from "react";
import { X } from "lucide-react";
import { DOCTOR_IMG } from "./DoctorChat";

export const DoctorFab = ({ t, onClick, active, showBubble }) => {
  const [phase, setPhase] = useState("in");
  const close = () => { setPhase("out"); setTimeout(() => setPhase("gone"), 600); };
  return (
  <div className="absolute bottom-6 left-4 z-20 flex flex-col items-start sm:left-6">
    {showBubble && phase !== "gone" && (
      <div data-testid="doctor-bubble" onClick={onClick}
        className={`card ${phase === "in" ? "bubble-in" : "bubble-out"} relative mb-3 max-w-[280px] cursor-pointer whitespace-pre-line rounded-2xl rounded-bl-sm py-3 pl-4 pr-9 text-[13px] leading-relaxed text-slate-700`}>
        <button data-testid="doctor-bubble-close-btn" aria-label={t("close")} onClick={(e) => { e.stopPropagation(); close(); }}
          className="absolute right-1.5 top-1.5 grid h-7 w-7 place-items-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-700"><X size={14} /></button>
        <strong className="font-display block text-[15px] text-slate-900">{t("bubble").split("\n")[0]}</strong>
        {t("bubble").split("\n")[1]}
        <span className="absolute -bottom-2 left-6 h-4 w-4 rotate-45 border-b border-r border-slate-200 bg-white/90" />
      </div>
    )}
    <button data-testid="doctor-open-btn" onClick={onClick} aria-label={t("doctor")}
      className={`${phase === "in" ? "wave" : ""} pulse-ring relative h-16 w-16 rounded-full shadow-lg ring-4 ring-white transition-transform hover:scale-105`}>
      <img src={DOCTOR_IMG} alt="Dr. Nova" className="h-full w-full rounded-full object-cover object-top" />
      {active && <span className="absolute right-0 top-0 h-4 w-4 rounded-full border-2 border-white bg-orange-500" data-testid="doctor-active-dot" />}
    </button>
  </div>
);
};
